export const STICKY_HEADER_MARGIN_RIGHT = 38;
